import { render, staticRenderFns } from "./step_3.vue?vue&type=template&id=65b653d9&scoped=true&lang=pug&"
import script from "./step_3.vue?vue&type=script&lang=js&"
export * from "./step_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b653d9",
  null
  
)

export default component.exports